// import React from 'react';

export const minCol = {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
}

export const maxCol = {
    sm: '575px',
    md: '767px',
    lg: '991px',
    xl: '1199px',
    xxl: '1399px',
}
